export const citiesUrl = '/content/cities'
export const faqsUrl = '/content/faqs'
